module.exports = __webpack_public_path__ + "img/field_on.18700400.svg";